import "bootstrap-icons/font/bootstrap-icons.css";
import "./css/App.css";
import { BrowserRouter as Router, Routes, Link, Route } from "react-router-dom";
import { useState } from "react";
import Wardroundpage from "./component/wardround";
import WardroundGroupListpage from "./component/wardround_grouplist";
import WardRoundAssessmentPage from "./component/wardround_assessment";
import Login_page from "./component/login_page";
import MailHtml from "./component/htmlMail";
import ListStudentHL from "./component/listStudent_hightlight";
import CamaraVideo from "./component/camara_video";
import CanvasPinText from "./component/canvas_pin_text";
import Viewpdfpage from "./component/viewpdfpage";
import Residenthome from "./component/resident/resident_home";
import ListmenuTopic from "./component/resident/listmenu_topic";
import Logbook from "./component/resident/logbook";
import LoginFormapage from "./component/login_formpage";
import Pageconfirmshare from "./component/pageconfirmshare";
import Page404 from "./component/page404";
import RegisterNotification from "./component/registerNotifaication";
import Page202Confrimshare from "./component/page202_confrimshare";

function App() {
  // const [assessYear, setAssessYear] = useState();
  const [studentGrp, setStudentGrp] = useState();
  const [sheetID, setSheetID] = useState();
  const [wordID, setwordID] = useState();
  const [urlImage, setUrlImage] = useState([]);
  const [arrPdfcomment, setArrPdfcomment] = useState([]);
  const [advisor_id, setAdvisor_id] = useState(null);
  const [advisor_pin, setAdvisor_pin] = useState(null);
  // function getYearToAssess(year) {
  //   setAssessYear(year);
  // }
  const handlegetIdadvisorformloginform = (id_advisor, pin_advisor) => {
    setAdvisor_id(id_advisor);
    setAdvisor_pin(pin_advisor);
  };

  return (
    <Router
      basename={"/estimate"}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Routes>
        {/* doctor */}
        <Route
          path="/pinlogin"
          element={
            <Login_page
              IdAdvisor={advisor_id}
              PinAdvisor={advisor_pin}
            ></Login_page>
          }
        ></Route>
        <Route
          path="/"
          element={
            <LoginFormapage
              handleSetid_advisor={handlegetIdadvisorformloginform}
            ></LoginFormapage>
          }
        />
        {/* <Route path="/" element={<Login_page></Login_page>} /> */}
        <Route
          path="/listWork"
          element={
            <Wardroundpage
              setGroupStudent={setStudentGrp}
              setSheetID={setSheetID}
              setWorkID={setwordID}
              studentGrp={studentGrp}
              sheetID={sheetID}
              workId={wordID}
            ></Wardroundpage>
          }
        ></Route>
        <Route
          path="/grouplist/:grp/:sheet/:workId"
          element={<WardroundGroupListpage></WardroundGroupListpage>}
        ></Route>
        <Route
          path="/grouplistHL/:grp/:sheet/:workId"
          element={<ListStudentHL></ListStudentHL>}
        ></Route>
        <Route
          path="/assessment/:id/:grp/:sheet/:workId/"
          element={
            <WardRoundAssessmentPage
              ImageURL={urlImage}
              setImageURL={setUrlImage}
              Pdfcomment={arrPdfcomment}
              setPdfcomment={setArrPdfcomment}
            ></WardRoundAssessmentPage>
          }
        ></Route>
        <Route
          path="/viewPDF/:id/:grp/:sheet/:workId"
          element={<Viewpdfpage></Viewpdfpage>}
        ></Route>
        <Route path="/htmlMail" element={<MailHtml></MailHtml>}></Route>
        <Route
          path="/camaravideo/:id/:grp/:sheet/:workId"
          element={
            <CamaraVideo
              resultImage={setUrlImage}
              Imageresult={urlImage}
            ></CamaraVideo>
          }
        ></Route>
        <Route
          path="/canvaspin"
          element={<CanvasPinText></CanvasPinText>}
        ></Route>
        {/* resident */}
        <Route
          path="/resident_home"
          element={<Residenthome></Residenthome>}
        ></Route>
        <Route
          path="/listmenu_topic/:topic/"
          element={<ListmenuTopic></ListmenuTopic>}
        ></Route>
        <Route
          path="/logbook/:topic/:subject"
          element={<Logbook></Logbook>}
        ></Route>
        <Route
          path="/confirmsharework/:docobj"
          element={<Pageconfirmshare></Pageconfirmshare>}
        />
        <Route
          path="/registerNotification"
          element={<RegisterNotification></RegisterNotification>}
        />
        <Route path="/page404" element={<Page404></Page404>} />
        <Route
          path="/page202Confirmshare"
          element={<Page202Confrimshare></Page202Confrimshare>}
        />
      </Routes>
    </Router>
  );
}

export default App;
